export default {
    baseStyle: {
        textSize: {
            fontSize: {base: '16px', lg: '16px'}
        }
    }
}
